import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {GenericButton} from "../../../../components/buttons/customButtons";
import ProductPriceElement from "../../../../components/promotion/productPriceElement";
import {Collapse} from "reactstrap";
import {TT_DELETE, TT_REMOVE} from "../../../../components/i18n/toolTips";
import Separator from "../../../../components/Separator";
import GenericSwitch from "../../../../components/genericComponents/genericSwitch";

function PromotionProductItem(props) {
    const {item, index, onEdit, onDelete, onUpdatePrices, onManualUpdatePrices, handleStatusChange} = props;
    const [checkedClass, setCheckedClass] = useState('');
    const [showPriceDetail, setShowPriceDetail] = useState(false);

    useEffect(() => {
        if (item?.status === null) {
            setCheckedClass('promotion-product-item-null');
        } else if (item?.status) {
            setCheckedClass('promotion-product-item-checked');
        } else {
            setCheckedClass('promotion-product-item-unchecked');
        }
    }, [item?.status]);

    const setIconView = () => {
        let img;
        try {
            img = require("../../../../assets/images/icon/parks/svg/" + item.udnIcon + ".svg");
        } catch (e) {
            img = require("../../../../assets/images/icon/warning.svg");
        }
        return img;
    }

    const getUdnClass = () => {
        let colorClass = 'promotion-product-item ';

        if (item?.status !== null && item?.status) {
            colorClass += 'udn-color-' + item.udnCode.toLowerCase()
        } else {
            colorClass += 'udn-color-grey';
        }

        return colorClass;
    }

    // <i class="fa-solid fa-check"></i>
    // <i class="fa-solid fa-plus"></i>
    // <i class="fa-solid fa-xmark"></i>
    return (
        <div id={'promotion-product-item'} key={'promotion-product-item-' + index}
             className={getUdnClass()}>

            <div id={'product-header'} key={'product-header-' + index} className="promotion-product-item-header">
                <span className="sivexCode">{item.productSivexCode}</span>
                <span className="sivexID">{item.productSivexId}</span>
                <span className="name">{item.productName}</span>

                <div id={'toolbar'} key={'toolbar-' + index} className="toolbar">
                    <div className="status">
                        <GenericSwitch
                            id={item?.id}
                            initialState={item?.status}
                            onChange={handleStatusChange}
                            labelText={'Activo'}
                        />
                    </div>
                    <GenericButton
                        style={'table'}
                        toolTip={'Actualizar precios'}
                        icon={'fa-dollar-sign'}
                        permission={'prices'}
                        onClick={() => onUpdatePrices(item)}
                    />
                    <GenericButton
                        style={'table'}
                        toolTip={'Actualizar precios manualmente'}
                        icon={'fa fa-money'}
                        permission={'prices'}
                        onClick={() => onManualUpdatePrices(item)}
                    />
                    <Separator/>
                    <GenericButton
                        style={'table'}
                        toolTip={'Editar'}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={() => onEdit(item)}
                    />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => onDelete(item)}
                    />
                </div>
            </div>

            <div id={'main-product'} key={'main-product-' + index} className="product-details">
                <div className={'product-udn-icon-container'}>
                    <img className={'product-udn-icon'} src={setIconView()} alt={item.udnName}/>
                </div>
                <span className="udnName">{item.udnName}</span>
                <span className="typeProductName">{item.typeProductName}</span>
                <span className="categoryProductName">{item.categoryProductName}</span>
                <span className="uid">{item.uid}</span>
            </div>

            {
                item?.productSubstitute?.sivexId &&
                <div id={'product-substitute'} key={'product-substitute-' + index} className="product-substitute">
                    <span className="sivexID">{item?.productSubstitute?.sivexId}</span>
                    <span className="sivexCode">{item?.productSubstitute?.sivexCode}</span>
                </div>

            }


            {
                item?.components !== null && item?.components?.length !== 0 &&
                <div id={'product-components'} key={'product-components-' + index} className="product-components">
                    <div id={'product-component'} key={'product-component-header'}
                         className="product-component-item">
                        <span className="component">{'Componentes'}</span>
                        <span>{''}</span>
                    </div>
                    {item?.components?.map((component, indexComponent) => {
                        return (
                            <div id={'product-component'} key={'product-component-' + indexComponent}
                                 className="product-component-item">
                                <span className="sivexID">{component.sivexId}</span>
                                <span className="sivexCode">{component.sivexCode}</span>
                            </div>
                        );
                    })}
                </div>
            }

            <div className={'section-see-more'}>
                <div className="float-right">
                    <span onClick={() => setShowPriceDetail(!showPriceDetail)}>{!showPriceDetail ? 'Ver detalle de precios' : 'Ocultar detalle de precios'}</span>
                </div>
            </div>
            <div id={'price-detail'} key={'price-detail-' + index} className={"product-price-detail"}>
                <Collapse isOpen={showPriceDetail}>
                    <ProductPriceElement row={item}/>
                </Collapse>
            </div>
        </div>
    );
}

PromotionProductItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdatePrices: PropTypes.func.isRequired,
    onManualUpdatePrices: PropTypes.func.isRequired
};

export default PromotionProductItem;